<script lang="ts">
  export let text: string
</script>

<div class="jse-tooltip">
  {text}
</div>

<style src="./Tooltip.scss"></style>
